import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { fetchMasterListById } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import ItemService from "../../../../services/commonService";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import Form from "react-bootstrap/Form";

const ReworkQuantityModal = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [reworkQuantity, setReworkQuantiy] = useState();
  const [deptList, setDeptList] = useState([]);
  const [userList, setUserList] = useState([]);
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  let [userId, setUserId] = useState();
  let [firstName, setFirstName] = useState();
  
  let [reasonName, setReasonName] = useState();
  let [reasonCode, setReasonCode] = useState();
  const [validate, setValidate] = useState(false);
  const [processList,setProcessList] = useState([]);
  const [reasonsList,setReasonsList] = useState([]);
  const [order,setOrder] = useState('');
  const formRef = useRef(null);
  const [error, setError] = useState(false);
  const [reasonError,setReasonError] = useState(false);
  const [userError,setUserError] = useState(false);

  useEffect(() => {
    let param = {};
    param.url = "getProcessMasterListDataById";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = props.sizeCode;
    if (props.sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data[0]) {
          const processArr = result?.payload?.data[0]?.process
          setProcessList(processArr);
          let processOrder
          // eslint-disable-next-line array-callback-return
          processArr.map((item)=>{
            if(item.deptCode === props.deptCode){
              processOrder = parseInt(item.processOrder)
            }
          })
          let deptFilter = processArr.filter(
            (process) => parseInt(process.processOrder) < parseInt(processOrder)
          );
          setDeptList(deptFilter);
        }
      });

      let userparam = {};
      userparam.url = "getAllOperatorsAndLead";
      userparam.page = Constants.MASTER.PROCESS.name;
      userparam.categoryList = [Constants.MASTER.USERS.OPERATOR,Constants.MASTER.USERS.TEAMLEAD]
      dispatch(fetchMasterListById(userparam)).then((result) => {
        if (result?.payload?.data[0]) {
          setUserList(result?.payload?.data);
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = (event) => {
    setReworkQuantiy("");
    setDeptCode("");
    setDeptName("");
    setReasonName("");
    setReasonCode("");
    setUserId("");
    setFirstName("");
    setReasonsList([]);
    props.onHide();
  };

  const handleSetOrder = (deptCode) => {
    processList.forEach((item)=>{
      if(item.deptCode === deptCode){
        setOrder(item.processOrder)
      }
    })
  };

  const handleSave = (event) => {
    const form = formRef.current;
    if (!deptCode) {
      setError(true);
      return;
    } else if(!reasonCode) {
      setReasonError(true);
      return 
    } else if(!userId) {
      setUserError(true);
      return 
    }
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    }
    if(reworkQuantity !== 0) {
      const row = {
        reasonName: reasonName,
        count: reworkQuantity,
        reworkorder:order,
        reasonCode: reasonCode,
        jobstatus:props.jobStatusCode,
        reworkDeptCode: deptCode,
        reworkDeptName: deptName,
        assignedUserId:userId,
        assignedFirstName:firstName,
        actualWt: "0",
        unitWt: "0",
      }
      props.accumulateActualValue(reworkQuantity,props.jobStatusCode,row);
      onHide();
    }
  };

  const deptResult =
    deptList &&
     deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

  const userResult =
    userList &&
    userList.map(({ userId, firstName }) => ({ userId, firstName: `${userId} - ${firstName}` }));

    const handleReworkReasonByDept = async (deptCode) => {
      let param = {};
    param.url = "getReasonDataByJobIdDeptCode";
    param.page = Constants.MASTER.REASON.name;
    param.id = props.jobStatusCode;
    param.deptCode = deptCode;

    await ItemService.getMasterListDataById(param).then((item) => {
      if (item?.status === 200) {
        const reasonResult =
        item?.data &&
        item?.data.map(({ reasonCode, reasonName }) => {
          return {
            reasonCode,
            reasonName,
            reason: reasonCode + " : " + reasonName
        }
      });
        setReasonsList(reasonResult);
      } else {
        toast.error(item?.message || "Please try again ", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    };

  const { show, onHide } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation={false}
      backdrop="static"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {t("msg_trasaction.order_confirmation.rework_page_title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
       <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_machines.select_department")}
            </Form.Label>
            <DropdownListField
              required
              id="deptCode"
              name="deptName"
              className="dropdownHive w-full rounded-md"
              data={deptResult}
              value={deptCode}
              onChange={(value) => {setDeptCode(value?.deptCode);setDeptName(value?.deptName);
                                    handleReworkReasonByDept(value?.deptCode, value?.deptName);handleSetOrder(value?.deptCode)}}
              placeholder={t("msg_master_list.msg_machines.select_department")}
              autoFocus={true}
              error={error}
             disabled={!deptResult}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_trasaction.rework_jobcard.select_rework_reason")}
            </Form.Label>
            <DropdownListField
              id="reasonCode"
              name="reason"
              className="dropdownHive w-full rounded-md"
              data={reasonsList}
              value={reasonCode}
              required
              onChange={(value) => {setReasonCode(value?.reasonCode);setReasonName(value?.reasonName);setReasonError(false) }}
              placeholder={t("msg_trasaction.rework_jobcard.select_rework_reason")}
              autoFocus={false}
              error={reasonError}
              disabled={reasonsList.length<=0}
            />
          </Form.Group> <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_trasaction.rework_jobcard.rework_assignee")}
            </Form.Label>
            <DropdownListField
              required
              id="userId"
              name="firstName"
              className="dropdownHive w-full rounded-md"
              data={userResult}
              value={firstName}
              onChange={(value) => {setUserId(value?.userId);setFirstName(value?.firstName);
                                    setUserError(false)
                                   }}
              error={userError}
              placeholder={t("msg_trasaction.rework_jobcard.rework_assignee")}
             disabled={!userResult}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_trasaction.order_confirmation.enter_rework_quantity")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={reworkQuantity}
              onChange={(e) => setReworkQuantiy(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_trasaction.order_confirmation.rework_quantity_validation")}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
    
  );
};

export default ReworkQuantityModal;
